import React, {Component} from 'react';
import couterpart from 'counterpart';
import {ToastsContainer, ToastsStore} from 'react-toasts';

import WorkOrderDataService from '../services/WorkOrderDataService';
import AuthenticationService from '../services/AuthenticationService';
import '../css/style.css';
import { ICON_COLOR } from '../icon';
import {FaUpload} from 'react-icons/fa';
import {MdFileUpload} from 'react-icons/md';

class UploaderWorkOrderImage extends Component{
    state = {
        file: null
    }

    handleFile(e){
        console.log(e.target.files, "$$$$");
        let file = e.target.files;
        
        this.setState({file}, ()=>{
            if (file != null && file.length > 0){
                var selectedFiles = "";
                var fileSep = "";
                for(var i=0; i<file.length;i++){
                    selectedFiles += fileSep + file[i].name;
                    fileSep = ",";
                }
                
                this.setState({
                    selectedFilenames: selectedFiles
                }, () =>{
                    this.props.onFileChanged(this.state.selectedFilenames); 
                });
            }
        }); 
    }

    handleUpload(e){
        console.log(this.state, "The state $$$");
        let files = this.state.file;
        var msg = "";
        if ((files === null) || (files === undefined) || (files.length < 1)){
            msg = couterpart.translate("msg_upload_validate_file");
            ToastsStore.error(msg);
            return;
        }

        if ((this.props.workOrderId === null) || (this.props.workOrderId === undefined) || (this.props.workOrderId < 1)){
            msg = couterpart.translate("msg_upload_validate_id");
            ToastsStore.error(msg);
            return; 
        }
        
        if (AuthenticationService.isDesigner()){
            WorkOrderDataService.uploadImageFiles(files, 
                this.props.workOrderId, 
                this.props.imageType).then(data => {
                this.props.handleUpdate(e);
                this.clearInputFile(e);
            });
        }
    }

    clearInputFile(e){
        //this.setState({file: null, selectedFilenames: '',inputKey:''});
    }

    handleRefresh(e){
        this.props.handleUpdate(e);
    }

    render(){
        if ((AuthenticationService.isAdmin() || AuthenticationService.isDesigner()) && (this.props.mode === 'MODE_EDIT')){
            return (
                <div>
                    <h3>{this.props.caption}</h3>
                    <ToastsContainer store={ToastsStore} position="bottom_center" />
                    <form name="frmImage">
                        <div>
                            <label htmlFor={"file" + this.props.imageType}>
                                <MdFileUpload color="green"/>
                            </label>
                            <input type="file" id={"file" + this.props.imageType} key={this.props.imageType} 
                                name={"file" + this.props.imageType} onChange={(e) => this.handleFile(e)}/>
                        </div>
                        <button className="myButton" type="button" 
                            onClick={(e) => this.handleUpload(e)}>
                            <FaUpload color={ICON_COLOR}/>&nbsp;
                            {couterpart.translate('button_upload')}
                        </button>
                    </form>
                </div>
            );
        }else{
            return(<div>&nbsp;</div>);
        }
    }
}

export default UploaderWorkOrderImage;